module.exports = __webpack_public_path__ + "static/media/elaborated-white.cd24b0ea.svg";